import React from "react";
import CategoryIcon from "@/components/CategoryIcon";

const BLOB = ["#FFD23F", "#8FB2FF", "#6FE0A0"];
const pick = (key = "") => BLOB[[...key].reduce((a, c) => a + c.charCodeAt(0), 0) % 3];

export function IconBlob({ icon, seed, size = 26 }) {
  return (
    <span className="relative shrink-0 w-12 h-12 flex items-center justify-center">
      <span className="absolute w-9 h-9 rounded-full right-0 top-0 group-hover:scale-125 transition-transform duration-150" style={{ background: pick(seed || icon) }} />
      <span className="relative text-[#0F1230]"><CategoryIcon name={icon} size={size} strokeWidth={2.1} /></span>
    </span>
  );
}
